export const razor_payment_key = "rzp_live_eMvoE4yrQtNntY";
